var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.apiKey)?_c('div',[_vm._v("No API key available.")]):_vm._e(),(_vm.apiKey)?_c('div',[(_vm.html)?_c('iframe',{attrs:{"src":_vm.html}}):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }